/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_Import_Ready_CountInputs */



/**
* | output |
* | --- |
* | "{count} ready to add" |
*
* @param {Team_Manager_Import_Ready_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_ready_count = /** @type {((inputs: Team_Manager_Import_Ready_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Ready_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} prêt(s) à ajouter`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} bereit zum Hinzufügen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} pronti da aggiungere`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Готово к добавлению: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} listos para añadir`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 个可添加`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`追加可能: ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} जोड़ने के लिए तैयार`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} prontos a adicionar`)
	return /** @type {LocalizedString} */ (`${i?.count} ready to add`)
});